import React from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import { auth } from "../../Api";

import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { withRouter, Link } from "react-router-dom";
import { AutoComplete, Input as AInput } from 'antd';
import 'react-phone-number-input/style.css'
import LocalPhoneField from '../../components/people/localPhoneField'
import { loadCompanyDialCode, toInternational, phoneProblem, formatPhone, phoneWithCount } from '../../utils/phone'
import { formatServerMessage } from '../../utils/serverErrors'
import { personName, isSharedPhoneReply, sharedPhoneState, confirmedSharedPhoneRequest } from '../../utils/people'
import SharedPhoneModal from '../../components/people/sharedPhoneModal'
import { deleteSucceeded, deleteFailedMessage, DELETE_UNREACHABLE } from '../../utils/deleteReply'
import { titleCell } from '../../utils/tables'

const { getCode, getName } = require('country-list');

class ReSellers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
			open: false,
			modal: false,
			obj: {},
			jsonData: [],
			originData: [],
			data: data.makeData(),
			treedata: data.treedata,
			companyName: '',
			defaultPageSize: 10
		};
		this.toggle = this.toggle.bind(this);
		this.alertToggle = this.alertToggle.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		// The company's dialling code, put in front of a local number in the edit popup
		loadCompanyDialCode().then((dialCode) => this.setState({ dialCode: dialCode }))
		var defaultPageSize = localStorage.getItem('defaultPageSize')
		if (defaultPageSize != undefined) {
			this.setState({
				defaultPageSize: defaultPageSize
			})
		}
		let companyId = localStorage.getItem('companyId')
		let companyName = localStorage.getItem('companyName')
		var req = {}
		req.company_id = companyId
		auth.getClient(req)
			.then((res) => {
				if (res.data.code == 200) {
					this.setState({
						companyName: companyName,
						jsonData: res.data.message.users,
						originData: res.data.message.users
					})
				}
			});
	}

	toggle() {
		console.log(this.state.modal);
		this.setState({
			modal: !this.state.modal
		});
	}

	alertToggle() {
		this.setState({
			alertModal: !this.state.alertModal
		});
	}

	setPhoneNumber = (event) => {
		console.log("event of phone:", event)
		// A copy, so the field shows what is typed
		this.setState({ obj: Object.assign({}, this.state.obj, { phone: event }) })
	}

	handleSubmit = (event) => {
		event.preventDefault();
		// A copy: the list keeps what is saved, not what is typed
		let obj = Object.assign({}, this.state.obj);
		// The local number completed with the company's dialling code
		const phone = toInternational(obj.phone, this.state.dialCode);
		if (phone === null) {
			window.alert(phoneProblem(obj.phone, this.state.dialCode))
			return
		}
		obj.phone = phone;
		obj.name = event.target.name.value;
		obj.sname = event.target.sname.value;
		obj.pobox = event.target.pobox.value;
		// The form stays open until the client is saved (a question or a refusal leaves it as typed)
		this.saveQuickEdit(obj)
	}

	// A phone number someone else in the company also has is asked about first (code 409); Yes sends
	// the save again with confirm_shared_phone. Other refusals (e.g. CID already used) are shown.
	saveQuickEdit = (req) => {
		auth.updateClient(req)
			.then((res) => {
				if (isSharedPhoneReply(res)) {
					this.setState({ sharedPhone: sharedPhoneState(res, req, 'client') })
				}
				else if (res.data.code != 201) {
					window.alert(formatServerMessage(res.data.message, 'The client could not be saved.'))
				}
				else {
					// Saved: back to the list, loaded again (it used to keep the row as typed)
					this.setState({ modal: false })
					this.componentDidMount()
				}
			})
	}

	// samePerson: the person of another kind the admin said this is (Yes), or null (No, or Continue)
	confirmSharedPhone = (samePerson) => {
		const { req } = this.state.sharedPhone
		this.setState({ sharedPhone: null })
		this.saveQuickEdit(confirmedSharedPhoneRequest(req, samePerson))
	}

	goLocation = (prop) => {
		localStorage.setItem('clientId', prop.id)
		localStorage.setItem('clientName', personName(prop, 'client'))
		this.props.history.push('/client-location/' + prop.id)
	}

	// Reloads the list only after the server has deleted it; a refusal is shown
	deleteRow() {
		const { obj } = this.state
		this.setState({ alertModal: false })
		auth.deleteClient(obj)
			.then((res) => {
				if (deleteSucceeded(res)) {
					this.componentDidMount()
				} else {
					window.alert(deleteFailedMessage(res, 'The client could not be deleted.'))
				}
			})
			.catch(() => window.alert(DELETE_UNREACHABLE))
	}

	handleSearch = (value) => {
		console.log(["searchData.length==value:", value])
		var searchData = [];
		this.state.originData.map((prop, key) => {
			if (prop.name.toLowerCase().includes(value.toLowerCase())
				|| prop.sname.toLowerCase().includes(value.toLowerCase())) {
				searchData.push(prop)
			}
		})
		console.log(["searchData.length==00:", searchData.length])
		this.setState({ jsonData: searchData })
	};

	onSizeChange = (size, page) => {
		console.log("size,page::", size, page)
		localStorage.setItem('defaultPageSize', size)
		this.setState({
			defaultPageSize: size
		})
	}

	render() {
		const { data, obj, companyName, defaultPageSize } = this.state;
		const data2 = this.state.jsonData.map((prop, key) => {
			console.log("prop:", prop)
			if (prop.active == 1) prop.active = true
			if (prop.active == 0) prop.active = false
			return {
				id: key,
				name: (
					<a onClick={() => this.props.history.push('/client-info/' + prop.id)} style={{ cursor: "pointer" }}>{personName(prop, 'client')}</a>
				),
				cid: prop.CID,
				phone: formatPhone(prop.phone),
				// The first number, and "+N" when the person has N more
				phoneShown: phoneWithCount(prop),
				email: prop.email,
				pobox: prop.pobox,
				country: getName(prop.countrycode),
				noguard: prop.noguard,
				nolocation: prop.nolocation,
				edit: (
					<div className="justify-content-center">
						<Button className="btn-table-edit ml-1" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								modal: !this.state.modal,
								obj: prop,
							});
						}}><i className="mdi mdi-lead-pencil" style={{ color: "white" }} /></Button>
						&nbsp;<Button className="btn-table-remove" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								alertModal: !this.state.alertModal,
								obj: prop,
							});
						}}><i className="fas fa-trash-alt" style={{ color: "white" }} /></Button>
					</div>
				),
				linkPage: (
					<div>
						<span onClick={() => this.goLocation(prop)} style={{ cursor: "pointer" }}><i className="fas fa-pencil-alt"></i>&nbsp;Edit Location</span>
					</div>
				)
			};
		});

		return <div>
			<Modal isOpen={this.state.modal} 
			backdrop={true}
			toggle={this.toggle}>
				<ModalHeader toggle={this.toggle}><h3>Client Edit</h3></ModalHeader>
				{
					obj == {} ? <div></div> : <ModalBody>
						<Form onSubmit={this.handleSubmit}>
							{/* <Input type="hidden" name="id" id="id" defaultValue={obj.id} /> */}
							<FormGroup>
								<Label for="name">First name</Label>
								<Input type="text" name="name" id="name" defaultValue={obj.name} />
							</FormGroup>
							<FormGroup>
								<Label for="sname">Last name</Label>
								<Input type="text" name="sname" id="sname" defaultValue={obj.sname} />
							</FormGroup>
							<FormGroup>
								<Label for="age">Phone</Label>
								<LocalPhoneField
									dialCode={this.state.dialCode}
									value={obj.phone}
									onChange={this.setPhoneNumber}
									editing={{ kind: 'client', id: obj.id }}
									suggest />
							</FormGroup>
							<FormGroup>
								<Label for="country">Address</Label>
								<Input type="text" name="pobox" id="pobox" defaultValue={obj.pobox} />
							</FormGroup>
							<FormGroup style={{ textAlign: "center" }}>
								<Button color="primary" className="modal-btn mr-1" type="submit">Save</Button>
								<Button color="secondary" className="modal-btn ml-1" onClick={this.toggle}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>}
			</Modal>
			<Modal isOpen={this.state.alertModal} toggle={this.alertToggle}>
				{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>Delete this client?</h2>
					<div>This deletes the client for good, with their locations and all their duties (and those duties alerts and tracking), and signs them out of the app. Guards assigned to them are kept.</div>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" className="modal-btn ml-1" onClick={this.alertToggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" className="modal-btn mr-1" onClick={() => this.deleteRow()}>Yes, Delete It!</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<SharedPhoneModal
				isOpen={this.state.sharedPhone != null}
				message={this.state.sharedPhone ? this.state.sharedPhone.message : ''}
				details={this.state.sharedPhone ? this.state.sharedPhone.details : []}
				person={this.state.sharedPhone ? this.state.sharedPhone.person : null}
				onYes={this.confirmSharedPhone}
				onNo={() => this.confirmSharedPhone(null)}
				onCancel={() => this.setState({ sharedPhone: null })} />
			{/*--------------------------------------------------------------------------------*/}
			{/* Start Action table*/}
			{/*--------------------------------------------------------------------------------*/}
			<div className="height-10"></div>
			<Card>
				{/* <CardTitle className="mb-0 p-3 border-bottom bg-light">
					
				</CardTitle> */}
				<CardBody>
					<div className="add-button add-button-top">
						<Button onClick={() => { this.props.history.push('/client-edit/null') }} className="btn" color="primary" size="lg" active>
							<i className="fas fa-user-plus"></i> Add New Client
						</Button>
						{/* <Button className="btn" color="primary" size="lg" active>
							<a href="/client-edit" ><i className="fas fa-user-plus"></i> Add New Client</a>
						</Button> */}
					</div>
					<Row className="table-header">
						<div className="table-title"><i className="fas fa-users"></i><span> Clients - {companyName}</span></div>
						<div style={{ width: 300 }} className="auto-complete">
							<AutoComplete
								dropdownMatchSelectWidth={252}
								style={{
									width: 300,
								}}
								options={[]}
								onSearch={this.handleSearch}
							>
								<AInput size="large" placeholder="Search" />
							</AutoComplete>
						</div>
					</Row>
					<ReactTable
						columns={[
							{
								Header: "No",
								id: "row",
								maxWidth: 50,
								filterable: false,
								Cell: (row) => {
									return <div>{row.index + 1}</div>;
								}
							},
							{
								Header: "Name",
								accessor: "name"
							},
							{
								Header: "CID",
								accessor: "cid",
								Cell: titleCell,
							},
							{
								Header: "PHONE",
								accessor: "phoneShown",
								Cell: titleCell,
							},
							{
								Header: "EMAIL",
								accessor: "email",
								Cell: titleCell,
							},
							{
								Header: "Address",
								accessor: "pobox",
								Cell: titleCell,
							},
							{
								Header: "NO.Of Guard",
								accessor: "noguard"
							},
							{
								Header: "NO.Of Location",
								accessor: "nolocation"
							},
							{
								Header: "Actions",
								accessor: "linkPage",
								minWidth: 120,
								// id: "row",
								maxWidth: 150,
								filterable: false,
							},
							{
								Header: "",
								accessor: "edit",
								minWidth: 100,
								id: "row",
								maxWidth: 100,
								filterable: false,

							},
						]}
						pageSize={defaultPageSize}
						showPaginationBottom={true}
						pageSizeOptions={[5, 10, 15, 20, 30, 40, 50]}
						onPageSizeChange={(size, number) => this.onSizeChange(size, number)}
						className="-striped -highlight"
						data={data2}
					// filterable
					/>
				</CardBody>
			</Card>
			{/*--------------------------------------------------------------------------------*/}
			{/* End Action table*/}
			{/*--------------------------------------------------------------------------------*/}
		</div>
	}
}

export default withRouter(ReSellers);
